module.exports = __webpack_public_path__ + "img/file_new.1ae0ba99.svg";